module.exports = __webpack_public_path__ + "img/freefire-uid-guide.d2f1d0f.png";